import { combineReducers } from "@reduxjs/toolkit";
import adminsReducer from "../features/admins/adminsSlice";
import adsWhitelistReducer from "../features/adsWhitelist/adsWhitelistSlice";
import adminStatisticsReducer from "../features/adminStatistics/adminStatisticsSlice";
import adminActionLogsReducer from "../features/adminActionLogs/adminActionLogsSlice";
import appAdminsReducer from "../features/appAdmins/appAdminsSlice";
import appVersionReducer from "../features/appVersion/appVersionSlice";
import confirmationModalReducer from "../features/confirmationModal/ConfirmationModalSlice";
import controlledHierarchyReducer from "../features/controlledHierarchy/controlledHierarchySlice";
import controlledSetNumbersReducer from "../features/controlledSetNumbers/controlledSetNumbersSlice";
import controlledTournamentsReducer from "../features/controlledTournaments/controlledTournamentsSlice";
import regionImagesReducer from "../features/images/regionImages/regionImagesSlice";
import tournamenImageReducer from "../features/images/tournamentImages/tournamentImagesSlice";
import multiPurposeImagesReducer from "../features/images/multiPurposeImages/multiPurposeImagesSlice";
import userImagesReducer from "../features/images/userImages/userImagesSlice";
import notificationReducer from "../features/notificationSlice/notificationSlice";
import playersReducer from "../features/players/playersSlice";
import prizeDeliveryReducer from "../features/prizeDelivery/prizeDeliverySlice";
import regionsReducer from "../features/regions/regionsSlice";
import resultLogIngestReducer from "../features/resultLogIngestSlice/resultLogIngestSlice";
import rolesReducer from "../features/roles/rolesSlice";
import roomSetsReducer from "../features/roomSets/roomSetSlice";
import socialMediaReducer from "../features/socialMedia/socialMediaSlice";
import statusModalReducer from "../features/statusModal/statusModal";
import supportChatReducer from "../features/supportChat/supportChatSlice";
import tablesReducer from "../features/tables/tableSlice";
import timelinesReducer from "../features/timelines/timelinesSlice";
import timeZoneReducer from "../features/timeZoneSlice/timeZoneSlice";
import tournamentsReducer from "../features/tournaments/tournamentsSlice";
import tournamentSearchReducer from "../features/tournamentSearch/tournamentSearchSlice";
import tournamentCommentReportsReducer from "../features/tournamentCommentReports/tournamentCommentReportsSlice";
import tournamentAllCommentsReducer from "../features/tournamentAllComments/tournamentAllCommentsSlice";
import squadBannersReducer from "../features/squadBanners/squadBannersSlice";
import squadsReducer from "../features/squads/squadsSlice";
import userReducer from "../features/user/userSlice";
import usersReducer from "../features/users/usersSlice";
import userSearchReducer from "../features/userSearch/userSearchSlice";

const appReducer = combineReducers({
  user: userReducer,
  statusModal: statusModalReducer,
  adsWhitelist: adsWhitelistReducer,
  adminStatistics: adminStatisticsReducer,
  adminActionLogs: adminActionLogsReducer,
  appAdmins: appAdminsReducer,
  admins: adminsReducer,
  timeZone: timeZoneReducer,
  confirmationModal: confirmationModalReducer,
  roles: rolesReducer,
  tournaments: tournamentsReducer,
  multiPurposeImages: multiPurposeImagesReducer,
  tournamentImages: tournamenImageReducer,
  tournamentSearch: tournamentSearchReducer,
  regions: regionsReducer,
  regionImages: regionImagesReducer,
  users: usersReducer,
  userImages: userImagesReducer,
  userSearch: userSearchReducer,
  roomSets: roomSetsReducer,
  timelines: timelinesReducer,
  tables: tablesReducer,
  players: playersReducer,
  controlledSetNumbers: controlledSetNumbersReducer,
  controlledHierarchy: controlledHierarchyReducer,
  controlledTournaments: controlledTournamentsReducer,
  supportChat: supportChatReducer,
  notification: notificationReducer,
  socialMedia: socialMediaReducer,
  prizeDelivery: prizeDeliveryReducer,
  appVersion: appVersionReducer,
  resultLogIngest: resultLogIngestReducer,
  tournamentCommentReports: tournamentCommentReportsReducer,
  tournamentAllComments: tournamentAllCommentsReducer,
  squadBanners: squadBannersReducer,
  squads: squadsReducer,
});

const rootReducer = (state, action) => {
  if (
    action.type === "user/logout/fulfilled"
    // action.type === "user/login/fulfilled"
  ) {
    state = undefined;
  }
  // console.log("🌀 Redux action dispatched:", action.type);
  return appReducer(state, action);
};

export default rootReducer;
